import React from 'react';
import { Table, Tag } from 'antd';

// ตารางผลการส่ง CS รายเคลม ใช้ร่วมกันทั้งหลังอนุมัติ อนุมัติไม่ตัดประกัน และขอเลขเอกสาร CS
// rows: { claimCode, actionLabel?, status: 'SUCCESS' | 'FAILED' | 'PLAN' | 'BLOCKED', reference?, message }

const STATUS_TAG = {
  SUCCESS: { color: 'green', text: 'ผ่าน' },
  FAILED: { color: 'red', text: 'ไม่ผ่าน' },
  PLAN: { color: 'blue', text: 'จะดำเนินการ' },
  BLOCKED: { color: 'default', text: 'ส่งไม่ได้' },
};

const RESEND_ACTION_LABEL = {
  RESEND: 'ขอเลขเอกสาร CS',
  BLOCKED: '-',
};

export const CsSendResultTable = ({ rows, showAction = false }) => {
  const columns = [
    { title: 'เลขเคลม', dataIndex: 'claimCode', width: 150 },
    ...(showAction ? [{ title: 'การดำเนินการ', dataIndex: 'actionLabel', width: 140 }] : []),
    {
      title: 'ผล',
      dataIndex: 'status',
      width: 110,
      render: (status) => {
        const tag = STATUS_TAG[status] || STATUS_TAG.FAILED;
        return <Tag color={tag.color}>{tag.text}</Tag>;
      },
    },
    { title: 'เลข CS', dataIndex: 'reference', width: 160, render: (v) => v || '-' },
    { title: 'รายละเอียด', dataIndex: 'message', render: (v) => v || '-' },
  ];

  return (
    <Table
      size="small"
      rowKey={(row) => row.requestId || row.claimCode}
      columns={columns}
      dataSource={rows}
      pagination={rows.length > 10 ? { pageSize: 10 } : false}
      scroll={{ x: 640 }}
    />
  );
};

// ผลจาก approve-list / approve/no-deduct (result.items ที่ API แปะ sendCsResult มาให้)
export const rowsFromApproveResponse = (response) =>
  (response?.result?.items || []).map((claim) => {
    const result = claim?.sendCsResult;
    return {
      claimCode: claim?.claimCode,
      status: result?.sendCsStatus === 'SUCCESS' ? 'SUCCESS' : 'FAILED',
      reference: result?.refCsId,
      message: result ? result.message : 'ไม่ได้รับผลการส่ง CS',
    };
  });

// รายการจาก resend-cs/preview (ยังไม่ทำจริง)
export const rowsFromResendPreview = (items = []) =>
  items.map((item) => ({
    claimCode: item.claimCode,
    actionLabel: RESEND_ACTION_LABEL[item.action] || item.action,
    status: item.action === 'BLOCKED' ? 'BLOCKED' : 'PLAN',
    reference: item.refCsId,
    message: item.csOrderStatus ? `${item.message} (CS: ${item.csOrderStatus})` : item.message,
  }));

// ผลจาก resend-cs (ทำจริงแล้ว)
export const rowsFromResendResult = (items = []) =>
  items.map((item) => ({
    claimCode: item.claimCode,
    actionLabel: RESEND_ACTION_LABEL[item.action] || item.action,
    status: item.action === 'BLOCKED' ? 'BLOCKED' : item.success ? 'SUCCESS' : 'FAILED',
    reference: item.refCsId,
    message: item.message,
  }));

const summary = (rows) => {
  const passed = rows.filter((row) => row.status === 'SUCCESS').length;
  return `ทั้งหมด ${rows.length} รายการ: ผ่าน ${passed}, ไม่ผ่าน ${rows.length - passed}`;
};

// modal = instance จาก Modal.useModal() ของหน้านั้น
export const showCsSendResult = (modal, { title, rows, showAction = false, onOk }) =>
  modal.info({
    title,
    width: 860,
    okText: 'ตกลง',
    content: (
      <div>
        <p>{summary(rows)}</p>
        <CsSendResultTable rows={rows} showAction={showAction} />
      </div>
    ),
    onOk,
  });

// approvalSuccess describes approval; CS delivery can fail after the new claim was created.
export const rowsFromResendApproveResponse = (response) =>
  (response?.result?.items || []).map((item) => ({
    requestId: item.requestId,
    claimCode: item.claimCode || '-',
    status: item.approvalSuccess ? 'SUCCESS' : 'FAILED',
    reference: item.sendCsResult?.refCsId,
    message: [
      item.responseMsg,
      item.sendCsResult &&
        `CS: ${item.sendCsResult.sendCsStatus || '-'} — ${item.sendCsResult.message || '-'}`,
    ]
      .filter(Boolean)
      .join(' · '),
  }));
